type AnyObj = Record<string, any>;

export function getConsultaViewFull(resp: AnyObj): string | null {
  try {
    const dataJson = resp?.data_json?.[0];
    const resultado: AnyObj | undefined = dataJson?.RESULTADO;
    if (!resultado || typeof resultado !== "object") return null;

    const firstKey = Object.keys(resultado)[0];
    const consulta = resultado[firstKey]?.consulta ? resultado[firstKey]?.consulta : resultado[firstKey];
    const full = consulta?.view?.full;
    return typeof full === "string" && full ? full : null;
  } catch {
    return null;
  }
}
